import { Grid2 } from '@mui/material'
import { memo } from 'react'
import {
  faCircleCheck,
  faCircleExclamation
} from '@fortawesome/pro-duotone-svg-icons'

import PageTitle from '../shared/pageTitle/PageTitle'
import HowItWorks from './HowItWorks'
import Milestones from './Milestones'
import Invites from './Invites'
import brandConfig from 'brandConfig'

const InviteFriends = ({
  t,
  symbol,
  onCopyReferral,
  userTier,
  tiers,
  referralProfile: {
    isProcessing,
    invites: { rewarded, pending, rewardedCount, pendingCount, totalEarned }
  },
  authId
}) => {
  const pageTitle = t('referral.invite-friends')
  const referralMulti = userTier.tier.metadata?.referralMultiplier || 0
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('referral.invite-friends-desc', { symbol })}
      />
      <Grid2 container spacing={3}>
        <Grid2 size={{ xs: 12, md: 4 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <HowItWorks
                t={t}
                referralMulti={referralMulti}
                onCopyReferral={onCopyReferral}
                symbol={symbol}
                rewardedCount={rewardedCount}
                totalEarned={totalEarned}
                authId={authId}
              />
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 8 }}>
          <Grid2 container spacing={3}>
            <Grid2 size={{ xs: 12 }}>
              <Milestones
                t={t}
                symbol={symbol}
                rewardedCount={rewardedCount}
                referralMulti={referralMulti}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <Invites
                t={t}
                title={t('referral.rewarded-invites')}
                desc={t('referral.rewarded-invites-desc')}
                icon={faCircleCheck}
                isActive
                data={rewarded}
                isProcessing={isProcessing}
                count={rewardedCount}
                tiers={tiers}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              <Invites
                t={t}
                title={t('referral.pending-invites')}
                desc={t('referral.pending-invites-desc', {
                  name: brandConfig.name
                })}
                icon={faCircleExclamation}
                data={pending}
                isProcessing={isProcessing}
                count={pendingCount}
                tiers={tiers}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </>
  )
}

export default memo(InviteFriends)
